import BaseNumberVTextField, { enforceFormat } from './BaseNumberVTextField'

export const MAXIMUM_FRACTION_DIGITS = 4

const formatter = new Intl.NumberFormat('en-US', {})

export function enforceNumberFormat(event: unknown, amount: any) {
  enforceFormat(event, amount, MAXIMUM_FRACTION_DIGITS)
}

export default {
  /* eslint-disable no-console */
  extends: BaseNumberVTextField,
  props: {
    blurredFormat: {
      type: Function,
      default: (v: string) => {
        const num = parseFloat(v as unknown as string)
        return Number.isFinite(num) ? formatter.format(num) : v
      },
    },
  },
}
